import React from 'react';
import lightswitch from '../images/icons/ic-lightswitch.svg';

const Toggle = ({
  toggleView,
  currentView,
  viewNameLeft = 'List view',
  viewLeft = 'list',
  viewNameRight = 'Map view',
  viewRight = 'map',
}) => {
  console.log({ currentView, viewLeft, viewRight });
  return (
    <div className='flex items-center'>
      <button
        onClick={toggleView}
        data-view={viewLeft}
        className={`mini-label ${
          currentView === viewLeft ? 'font-medium' : ''
        }`}
      >
        {viewNameLeft}
      </button>
      <button onClick={toggleView}>
        <img
          src={lightswitch}
          className={`mx-3 w-7 ${currentView === viewLeft ? '' : 'rotate-180'}`}
        />
      </button>
      <button
        onClick={toggleView}
        data-view={viewRight}
        className={`mini-label ${
          currentView === viewRight ? 'font-medium' : ''
        }`}
      >
        {viewNameRight}
      </button>
    </div>
  );
};

export default Toggle;
